import React, { Fragment, useState, useEffect } from "react";
import { Breadcrumbs, Btn, H4 } from "../../AbstractElements";
import { useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import { MultiDropzone } from "../../myConstants/MultiDropzone";
import axios from "axios";
import { toast } from "react-toastify";
import UploadProjectFileClass from "../DealsSection/comp/UploadProjectFile";
import { useNavigate, useParams } from "react-router";

const categories = [
  { value: "dailyworkout", label: "Daily Workout" },
  { value: "workoutprogram", label: "Workout Programs" },
  { value: "singleexercise", label: "Single Exercise" },
  { value: "challenges", label: "Fitness Challenge" },
];

const ChallengesProgram = () => {
  const { id } = useParams();
  const token = useSelector((state) => state.auth.userToken);
  const admin = useSelector((state) => state.auth.userInfo._id);
  const [loader, setLoader] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({
    description: "",
    workOutName: "",
    duration: "",
    challangeDays: "",
    calories: "",
    reps: "",
    setLength: "",
    totalSets: "",
    typeS: "single", // Default value
    side: "left", // Default value
    image: "",
    video: "",
  });
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");

  useEffect(() => {
    const fetchChallenge = async () => {
      if (id) {
        setLoader(true);
        try {
          const response = await axios.get(
            `https://ovah-1-production.up.railway.app/api/add/getChallengeById/${id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          const data = response.data;
          setFormData({
            description: data.description,
            workOutName: data.workOutName,
            duration: data.duration,
            challangeDays: data.challangeDays,
            calories: data.calories,
            reps: data.reps,
            setLength: data.setLength,
            totalSets: data.totalSets,
            typeS: data.typeS,
            side: data.side || "left", // Default to "left" if not provided
            image: data.exercisePicUrl,
            video: "",
          });
          setImages([{ file: data.exercisePicUrl }]); // Assuming image is a URL
          setCurrentVideoUrl(data.exerciseVideoUrl); // Set the current video URL
          setLoader(false);
        } catch (error) {
          console.error("Error fetching challenge:", error);
          setLoader(false);
        }
      }
    };

    fetchChallenge();
  }, [id, token]);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };
  const history = useNavigate();

  const handleImageChange = (newImages) => {
    setImages(newImages);
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0]; // Get the first file selected by the user
    setFormData({
      ...formData,
      video: file, // Store the file object itself
    });
    setCurrentVideoUrl(URL.createObjectURL(file)); // Set the new video URL for preview
  };

  const handleDeleteVideo = () => {
    setCurrentVideoUrl("");
    setFormData({
      ...formData,
      video: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    const data = new FormData();
    data.append("admin", admin);
    data.append("description", formData.description);
    data.append("workOutName", formData.workOutName);
    data.append("duration", formData.duration);
    data.append("challangeDays", formData.challangeDays);
    data.append("calories", formData.calories);
    data.append("reps", formData.reps);
    data.append("setLength", formData.setLength);
    data.append("totalSets", formData.totalSets);
    data.append("typeS", formData.typeS);
    data.append("side", formData.side);
    if (formData.video) {
      data.append("video", formData.video);
    }

    const imageFile = images[0]; // Assuming images[0] contains a File object
    data.append("image", imageFile);

    try {
      let config = {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      };

      const response = id
        ? await axios.put(
            `https://ovah-1-production.up.railway.app/api/add/editChallenge/${id}`,
            data,
            config
          )
        : await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/add/addFitnessChallange`,
            data,
            config
          );

      if (response.status === 201 || response.status === 200) {
        toast.success(response.data.message);
        setLoader(false);
        setFormSubmitted(true);
        setFormData({
          workOutName: "",
          description: "",
          duration: "",
          calories: "",
          reps: "",
          setLength: "",
          totalSets: "",
          challangeDays: "",
          typeS: "single",
          side: "left",
          image: "",
          video: "",
        });
        setImages([]);
        setCurrentVideoUrl("");
        history("/programs");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setLoader(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      workOutName: "",
      description: "",
      duration: "",
      calories: "",
      reps: "",
      setLength: "",
      totalSets: "",
      challangeDays: "",
      typeS: "single",
      side: "left",
      image: "",
      video: "",
    });
    setImages([]);
    setCurrentVideoUrl("");
  };

  return (
    <div>
      <Breadcrumbs mainTitle="Challenges" parent="Challenges" title="Create Challenges" />
      {!loader ? (
        <Container fluid={true}>
          <H4>{id ? "Edit Challenge" : "Create Challenge"}</H4>
          <Row>
            <Col sm="12">
              <Card>
                <CardBody>
                  <Form className="theme-form" onSubmit={handleSubmit}>
                    <Row>
                      <Col md="12">
                        <FormGroup>
                          <Label for="description">Description</Label>
                          <Input
                            type="text"
                            id="description"
                            value={formData.description}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="workOutName">Workout Name</Label>
                          <Input
                            type="text"
                            id="workOutName"
                            value={formData.workOutName}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="duration">Duration (minutes)</Label>
                          <Input
                            type="number"
                            id="duration"
                            value={formData.duration}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="calories">Calories</Label>
                          <Input
                            type="number"
                            id="calories"
                            value={formData.calories}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="reps">Reps</Label>
                          <Input
                            type="number"
                            id="reps"
                            value={formData.reps}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="setLength">Set Length</Label>
                          <Input
                            type="number"
                            id="setLength"
                            value={formData.setLength}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="totalSets">Total Sets</Label>
                          <Input
                            type="number"
                            id="totalSets"
                            value={formData.totalSets}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="4">
                        <FormGroup>
                          <Label for="challangeDays">Challenge Days</Label>
                          <Input
                            type="text"
                            id="challangeDays"
                            value={formData.challangeDays}
                            onChange={handleInputChange}
                            required
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="typeS">Type</Label>
                          <Input
                            type="select"
                            id="typeS"
                            value={formData.typeS}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="single">Single</option>
                            <option value="double">Double</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <Label for="side">Side</Label>
                          <Input
                            type="select"
                            id="side"
                            value={formData.side}
                            onChange={handleInputChange}
                          >
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <FormGroup>
                        <Col sm="12">
                          <Label for="image">Exercise Picture URL</Label>
                          <MultiDropzone
                            id="image"
                            images={images}
                            setImages={handleImageChange}
                          />
                        </Col>
                      </FormGroup>
                    </Row>
                    <Row>
                    <Col md="6">
  <FormGroup>
    <Label for="video">Exercise Video</Label>
    {currentVideoUrl && (
      <div>
        <p>{decodeURIComponent(currentVideoUrl.split('/').pop())}</p> {/* Display decoded video name */}
        <Button color="danger" onClick={handleDeleteVideo}>
          Delete Video
        </Button>
      </div>
    )}
    <Input
      type="file"
      id="video"
      accept="video/*"
      onChange={handleVideoChange}
    />
  </FormGroup>
</Col>

                    </Row>
               
                    <Row>
                      <Col>
                        <div className="text-end">
                          <Button color="success" type="submit" className="me-3">
                            {id ? "Edit Challenge" : "Add Challenge"}
                          </Button>
                          <Button color="warning" type="button" onClick={handleCancel}>
                            Cancel
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      ) : (
        <div className="text-center my-5">
        <Spinner style={{ width: '3rem', height: '3rem' }} />
      </div>
      )}
    </div>
  );
};

export default ChallengesProgram;
